import { render } from "./item-section.vue?vue&type=template&id=1ca308d2&bindings={\"items\":\"props\",\"itemType\":\"props\",\"visible\":\"props\"}"
import script from "./item-section.vue?vue&type=script&lang=js"
export * from "./item-section.vue?vue&type=script&lang=js"

import "./item-section.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script